import { createContext } from 'react';
import type { ChatUser } from '@duke-hq/svc-support-web';
import type { Drn } from '@duke-hq/drn/type';

export const ChatActionsNoop = {
  // Get the user by their drn
  getUser: (_userDrn: Drn): ChatUser | undefined => {
    return undefined; // Placeholder, replace with actual implementation
  },
  // Get the chat meta by the chat id, used to fetch names in the chat list
  // and other metadata. This function is called when an event is received
  // from the chat service that requires the chat meta to be updated.
  refetchChatMeta: async (_chatId: string) => {},
  sendTyping: async (_input: { chatId: string; typing: boolean }) => {},
  sendMessage: async (_input: { chatId: string; message: string }) => {},
};

export type ChatActions = typeof ChatActionsNoop;

export const ChatContext = createContext<ChatActions>(ChatActionsNoop);
